import { ExplorerProvider } from '@/services/explorer/ExplorerProvider';

import { SelectionProvider } from '@/services/selection/SelectionProvider';
import { createExplorerFromList, useList } from '@/utils/explorer';
import { FC, PropsWithChildren, useMemo } from 'react';
import { FilesExplorerSelectionBar } from './FilesExplorerSelectionBar';

export const SharedFilesExplorer: FC<PropsWithChildren> = ({ children }) => {
  const [list] = useList();

  const directories = useMemo(() => createExplorerFromList(list.value, []), [list]);

  return (
    <ExplorerProvider directories={directories} prefix="/resources">
      <SelectionProvider>
        <div className="flex flex-1 h-full items-stretch">{children}</div>
        <FilesExplorerSelectionBar />
      </SelectionProvider>
    </ExplorerProvider>
  );
};
